<template>
  <div class="answer-info-wrap" ref="answerInfo" :style="handleAnswerInfoStyle">
    <div class="top-wrap">
      <div class="user-info">
        <img :src="info.avatar" alt="" class="avatar" />
        <div class="info-wrap">
          <div class="name-wrap">
            <span>{{ info.nickname }} </span>
            <p
              v-if="isMyAnswer && info.score"
              class="rating-tag"
              :style="ratingStyle(info.score)"
            >
              {{ RATING[info.score] }}
            </p>
          </div>
          <p class="time">
            {{ moment(info.sub_time * 1000).format("MM月DD日") }}
            提交
          </p>
        </div>
      </div>
      <img
        v-if="isMyAnswer && info.corrected"
        class="corrected-icon"
        src="../../../assets/images/homework/corrected.png"
        alt=""
      />
      <!-- 同学作业操作 -->
      <el-popover
        v-else-if="!isMyAnswer"
        placement="bottom-end"
        width="60"
        trigger="click"
        v-model="visible"
        :visible-arrow="false"
        popper-class="homework-complaint-popover"
      >
        <button @click="showComplaintDialog">举报</button>
        <button slot="reference" class="more-btn">
          <img src="../../../assets/images/icon/more-icon.png" alt="" />
        </button>
      </el-popover>
    </div>
    <div
      v-if="info.answer"
      class="answer-cont"
      v-html="info.teacher_answer || info.answer"
    ></div>
    <!-- 老师点评信息 -->
    <div class="teacher-analysis" v-if="isMyAnswer && info.teacher_analysis">
      <p class="cont-title">
        {{ info.operator_name ? info.operator_name : "老师" }} 点评
      </p>
      <div class="analysis" v-html="info.teacher_analysis"></div>
    </div>
    <!-- 展开和收起 -->
    <div
      v-if="canShowAllInfo"
      class="show-all-info"
      :class="{
        isExpand: expand,
      }"
    >
      <button @click="handleExpand">
        <i v-if="expand" class="el-icon-arrow-up"></i>
        <i v-else class="el-icon-arrow-down"></i>
      </button>
    </div>
    <!-- 举报弹窗 -->
    <complaint-dialog ref="complaintDialog" />
  </div>
</template>

<script>
import { ComplaintDialog } from "@saas/components";
import {
  RATING,
  RATING_COLOR,
  RATING_BORDER_COLOR,
} from "@saas/components/src/constants/question";
import moment from "moment";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },

    isMyAnswer: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ComplaintDialog,
  },
  data() {
    return {
      visible: false,
      moment,
      canShowAllInfo: false,
      RATING,
      RATING_COLOR,
      RATING_BORDER_COLOR,
      expand: false,
    };
  },
  methods: {
    showComplaintDialog() {
      if (
        !this.info?.user_work_id ||
        !this.$refs?.complaintDialog?.showDialog
      ) {
        return false;
      }
      this.$refs?.complaintDialog?.showDialog(this.info.user_work_id);
    },
    handleExpand() {
      this.expand = !this.expand;
    },
  },
  computed: {
    ratingStyle() {
      return (value) => {
        return {
          color: RATING_COLOR[value],
          borderColor: RATING_BORDER_COLOR[value],
        };
      };
    },
    handleAnswerInfoStyle() {
      return {
        maxHeight: this.expand ? "none" : "260px",
      };
    },
  },
  watch: {
    info: {
      handler(val) {
        if (val.user_work_id) {
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs["answerInfo"]) {
                this.canShowAllInfo =
                  this.$refs["answerInfo"].offsetHeight >= 260;
              }
            }, 500);
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-info-wrap {
  position: relative;
  padding: 12px 16px 12px;
  max-height: 260px;
  overflow: hidden;
  color: var(--text-primary, #0d1400);
  .answer-cont {
    font-size: 14px;
    line-break: anywhere;
    color: var(--text-primary, #0d1400);
  }
  .top-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .corrected-icon {
      width: 58px;
      height: 58px;
      position: absolute;
      right: 0;
      top: -8px;
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 6px;
    }
    .name-wrap {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: var(--text-primary, #0d1400);
      line-height: 20px;
      margin-bottom: 2px;
    }
    .time {
      font-weight: 400;
      font-size: 11px;
      color: var(--text-secondary, #747573);
      line-height: 16px;
    }
  }
  .more-btn {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 1px solid var(--border-subtle, #e5e6eb);
    background: var(--surface-overlay, transparent);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .teacher-analysis {
    margin-top: 16px;
    padding: 12px;
    background: rgba(0, 200, 157, 0.08);
    border-radius: 12px;
    border: 1px solid #74ffe1;
    .cont-title {
      font-weight: 600;
      font-size: 14px;
      color: var(--text-primary, #0d1400);
      line-height: 20px;
      margin-bottom: 12px;
    }
    .analysis {
      line-break: anywhere;
      font-size: 14px;
    }
  }
  .rating-tag {
    height: 20px;
    border-radius: 4px;
    border: 1px solid #fdcdc5;
    font-weight: 500;
    font-size: 12px;
    color: #f53f3f;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    margin-left: 8px;
  }
  .show-all-info {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 27px;
    background: linear-gradient(
      180deg,
      rgba(250, 250, 251, 0) 0%,
      var(--input-bg, #f2f3f5) 100%
    );
    &.isExpand {
      background: transparent;
    }
    button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -7px;
      width: 20px;
      height: 20px;
      background: var(--surface-overlay, #ffffff);
      box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
      border-radius: 6px;
      border: 1px solid var(--border-subtle, #e5e6e8);
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        transition: transform 0.3s;
        color: var(--text-secondary, #4e5969);
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.homework-complaint-popover {
  min-width: auto;
  height: 36px;
  background: var(--surface-overlay, #ffffff);
  box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 8px;
  border: 1px solid var(--border-subtle, #e5e6e8);
  color: var(--text-primary, #0d1400);
  padding: 8px 0 0 16px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  margin-top: 0 !important;
}
</style>
